// Video mappings for Google Drive files with actual file IDs from the provided links

export const videoMappings = {
  // Anuvadini AI Demonstration Videos - Updated with actual file IDs
  "anuvadini-ai-qa-generator": "1c1gDKFi0_Qnng0XJb5kK5pBFKIPLySDl",
  "anuvadini-ai-animal-detection": "1vJxV60GME1Gs6XCndlMWZxBtI7C5AGIq",
  "anuvadini-ai-bujji-2": "1Qf-h-Y8GKZIBb3Xmm0poqrZYInVRQY8v",
  "anuvadini-ai-car-theft-detection": "1-n88jo_SQOzhSk5bCDQ2OqXNhKQwxJnb",
  "anuvadini-ai-chutki": "10_rs4FIFJBizMJiEGg0tu3ZfyLqHmg9r",
  "anuvadini-ai-exam-detection": "19IaEnY7cgMbqAcApg-os6O6f9m9mwPzS",
  "anuvadini-ai-object-detection": "1dJzd12qRoMrCurdHTBDmJd98I-AQ2qNC",
  "anuvadini-ai-ocr": "1-mMIPLp4E2-e1lU4gia9rquFj8qD_xt_",
  "anuvadini-ai-seating-detection": "1cjBLTvoq4Q_Vt4a6Vm2EycE8LepxM2yG",
  "anuvadini-ai-speakpic": "1iEyeizPFOd4wtKF7t6KCp2VbP31twjoc",
  "anuvadini-ai-theft-detection": "1WLGL8sl9XK38PLtGA5bXeAUqThdHr-Pi",
  "anuvadini-ai-traffic-vehicle-detection": "1tS7NyqVe062UHENJxYiNBzstS5x8p22Q",
  "anuvadini-ai-video-subtitle": "1OeQ_RVSt2U2H_ra3OAz4lCXwuDWkhgt4",
  "anuvadini-ai-voice-enabled-form-normal": "1OCGRnJnestXM2A8eC871mWiRVSob2McE",
  "anuvadini-ai-voice-enabled-voice-form": "1ZHKq8Fds1DzvT6iCuvYQWDFgfTvZJG8N",
  "anuvadini-ai-weapon-detection": "1pp9EAK3NEfn7Shuue8QbPsnoVyXPumHd",
  "anuvadini-surveillance-detection": "1KCM-lI1vpgaUR6bOPY3oBIIcbxSia08i",
  "ncert-in-design-002": "1nabWo-70qzGxfIqbSNFi-CxNY5aql0kM",
  "anuvadini-ai-buddha-ji-presentation": "1VVpDBK9IkJLa4HD3fSeiGLj7h4poiOvy",
  
  // Anuvadini Print Videos (already have correct IDs)
  "anuvadini-print-demo-1": "1A_4J_htxQ6FU6AwxFmyK0x0mY1YjZB_c",
  "anuvadini-print-demo-2": "1pFZ0DDwNXnkLPzad0EjeOMju_D_lxINu",
  "anuvadini-print-demo-3": "1OhNrJoPhjLH9pdveR8lBw9R-IuFvz1-3",
  "anuvadini-print-demo-4": "1wIYUwJQEVXd5kBQZeHXCNPLDd14TItdy"
};

// Helper function to generate Google Drive URLs
export const generateDriveUrl = (fileId: string) => {
  return `https://drive.google.com/file/d/${fileId}/view?usp=sharing`;
};

// Helper function to generate Google Drive thumbnail URL with multiple fallback options
export const generateDriveThumbnail = (fileId: string) => {
  // Try multiple Google Drive thumbnail endpoints
  return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1000-h600`;
};

// Create a fallback thumbnail URL generator
export const createFallbackThumbnail = (title: string) => {
  // Create a data URL for a simple gradient thumbnail with title
  const canvas = document.createElement('canvas');
  canvas.width = 1000;
  canvas.height = 600;
  const ctx = canvas.getContext('2d');
  
  if (ctx) {
    // Create gradient background
    const gradient = ctx.createLinearGradient(0, 0, 1000, 600);
    gradient.addColorStop(0, '#3B82F6');
    gradient.addColorStop(0.5, '#8B5CF6');
    gradient.addColorStop(1, '#EC4899');
    
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 1000, 600);
    
    // Add title text
    ctx.fillStyle = 'white';
    ctx.font = 'bold 48px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    
    // Wrap text if too long
    const maxWidth = 800;
    const words = title.split(' ');
    let line = '';
    const lines = [];
    
    for (let n = 0; n < words.length; n++) {
      const testLine = line + words[n] + ' ';
      const metrics = ctx.measureText(testLine);
      const testWidth = metrics.width;
      if (testWidth > maxWidth && n > 0) {
        lines.push(line);
        line = words[n] + ' ';
      } else {
        line = testLine;
      }
    }
    lines.push(line);
    
    // Draw lines
    const lineHeight = 60;
    const startY = 300 - (lines.length - 1) * lineHeight / 2;
    
    lines.forEach((line, index) => {
      ctx.fillText(line.trim(), 500, startY + index * lineHeight);
    });
    
    return canvas.toDataURL();
  }
  
  // Fallback if canvas fails
  return `data:image/svg+xml;base64,${btoa(`
    <svg width="1000" height="600" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:#3B82F6;stop-opacity:1" />
          <stop offset="50%" style="stop-color:#8B5CF6;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#EC4899;stop-opacity:1" />
        </linearGradient>
      </defs>
      <rect width="1000" height="600" fill="url(#grad)" />
      <text x="500" y="300" font-family="Arial, sans-serif" font-size="48" font-weight="bold" fill="white" text-anchor="middle" dominant-baseline="middle">${title}</text>
    </svg>
  `)}`;
};

// Helper function to get video data with proper URLs and thumbnails
export const getVideoData = (videoKey: keyof typeof videoMappings, title: string, customThumbnail?: string) => {
  const fileId = videoMappings[videoKey];
  return {
    title,
    url: generateDriveUrl(fileId),
    thumbnail: customThumbnail || generateDriveThumbnail(fileId)
  };
};